import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const NextToggle = ({
  id, 
  className, 
  children, 
  checked, 
  onClick,
  childrenOutsideLabel
}) => {
  let _id = (new Date()).toLocaleDateString(),
      _attr = {},
      _clickAction = () => {
        if (onClick) onClick();
      },
      _childrenOutside = (childrenOutsideLabel === true) ? children : null,
      _childrenInside = (childrenOutsideLabel === false) ? children : null;

  
  
  if (id) _attr.id = id;
  _attr.className = classnames("custom-toggle", className);

  return (
    <div {..._attr}>
      <div className={"custom-toggle-input"}>
        <input id={id} type={"checkbox"} checked={checked} onChange={(e) => {}}/>
        <label htmlFor={id} 
               onClick={_clickAction}
               className={"custom-toggle-label"}>
          {_childrenInside}
        </label>
        {_childrenOutside}
      </div>
    </div>
  );
};

NextToggle.defaultProps = {
  id: null,
  className: null,
  checked: false,
  childrenOutsideLabel: false
};

NextToggle.propTypes = {
  id: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  children: PropTypes.node,
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  childrenOutsideLabel: PropTypes.bool
};
